export default function CQuiz() {
  return <h2>C Quiz</h2>;
}
